import { Tooltip } from "antd";
import { IconExcel } from "../../../../assets/icons";
import * as XLSX from "xlsx";
import { valueFormatter } from "../utils/valueFormatter";

const AgGridToExcel = ({
  gridApi,
  rowData,
  title,
  tableCols,
  modifyRows,
  className,
  style,
  idKey,
}) => {
  //if export certain cols
  const handleClick = () => {
    let filteredRows = [];
    if (!!gridApi) {
      const selectedNodes = gridApi
        .getSelectedNodes()
        .map((node) => node.data?.[idKey]);
      gridApi.forEachNodeAfterFilterAndSort((node) => {
        if (!!selectedNodes?.length) {
          if (selectedNodes.includes(node.data?.[idKey]))
            filteredRows.push(node.data);
        } else {
          filteredRows.push(node.data);
        }
      });
    } else if (!!rowData && Array.isArray(rowData)) {
      filteredRows = [...rowData];
    }
    if (!filteredRows || filteredRows.length === 0) {
      return;
    }

    if (!!modifyRows && typeof modifyRows === "function") {
      filteredRows = modifyRows(filteredRows);
    }

    const rows = [];
    filteredRows?.forEach((row) => {
      const tableRow = {};
      tableCols?.forEach((col) => {
        const value = row[col?.en || col];
        if (col?.format) {
          //let excel format it below
          tableRow[col.al || col] = value;
        } else {
          tableRow[col?.al || col] = valueFormatter(col, value, false);
        }
      });
      rows.push(tableRow);
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    tableCols?.forEach((col, index) => {
      const isDateColumn =
        col?.format || (col?.en && col.en.toLowerCase().includes("date"));

      if (isDateColumn) {
        for (let row = range.s.r + 1; row <= range.e.r; row++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: index });
          const cell = worksheet[cellAddress];
          if (cell && cell.v) {
            const dateValue = new Date(cell.v);
            if (!isNaN(dateValue.getTime())) {
              cell.v = dateValue;
              cell.t = "d"; // date type
              cell.z = col?.format || "dd/mm/yyyy"; // date format
            }
          }
        }
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, title);

    // Save the workbook to a file
    XLSX.writeFile(workbook, `${title}.xlsx`);
  };
  return (
    <div
      className={`headerIcon ${className}`}
      data-testid="headerExcel"
      onClick={handleClick}
      style={style}
    >
      <Tooltip
        placement="top"
        classNames={{ root: "global-icon-tooltip" }}
        title={"Eksporto në Excel"}
      >
        <IconExcel width={20} height={20} fill={style?.fill || "#323338"} />
      </Tooltip>
    </div>
  );
};

export default AgGridToExcel;
